export const getNavMenu = state => state.navMenu.data
export const isNavMenuLoading = state => state.navMenu.loading
